import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHelpCenter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(1.4333, 1.0000)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M6.13355 13.5H1.80022C1.45544 13.5 1.12478 13.363 0.880986 13.1192C0.637188 12.8754 0.500225 12.5448 0.500225 12.2",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.9 4.83333V0.933333C10.9 0.818406 10.8543 0.708186 10.7731 0.62692C10.6918 0.545655 10.5816 0.5 10.4667 0.5H2.23333C1.77362 0.5 1.33274 0.682618 1.00768 1.00768C0.682618 1.33274 0.5 1.77362 0.5 2.23333V12.2C0.5 11.8552 0.636964 11.5246 0.880761 11.2808C1.12456 11.037 1.45522 10.9 1.8 10.9H3.96666",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.15533 11.3116C5.58647 10.7427 5.26689 9.97116 5.26689 9.16667C5.26689 8.36218 5.58647 7.59064 6.15533 7.02178C6.72419 6.45292 7.49573 6.13333 8.30022 6.13333C9.10471 6.13333 9.87625 6.45292 10.4451 7.02178C11.014 7.59064 11.3336 8.36218 11.3336 9.16667C11.3336 9.97116 11.014 10.7427 10.4451 11.3116C9.87625 11.8804 9.10471 12.2 8.30022 12.2C7.49573 12.2 6.72419 11.8804 6.15533 11.3116Z",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.6334 13.5L10.4448 11.3114",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgHelpCenter;
